import { Form }                from 'antd';
import { Upload }              from 'antd';
import { InboxOutlined }       from '@ant-design/icons';
import FormattedMessageWrapper from './FormattedMessageWrapper';

const Dragger = Upload.Dragger;

interface FormItemDraggerProps {
  label?: any;
  name: string;
  required?: boolean;
}

const FormItemDragger = (props: FormItemDraggerProps) => {
  const { label, name, required } = props;

  return (
    <Form.Item
      // help={getFieldError(name) || ''}
      getValueFromEvent={e => {
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.fileList;
      }}
      label={label}
      labelCol={{ span: 24 }}
      rules={[
        {
          message: <FormattedMessageWrapper id="Information manquante" />,
          required,
        },
      ]}
      valuePropName="fileList"
      // validateStatus={getFieldError(name) ? 'error' : ''}
      {...props}
      name={name}
    >
      <Dragger beforeUpload={() => false} multiple>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          <FormattedMessageWrapper id="Ajouter un ou plusieurs fichiers" />
        </p>
        <p className="ant-upload-hint">
          <FormattedMessageWrapper id="Cliquez-ici ou déposez un ou plusieurs fichiers." />
        </p>
      </Dragger>
    </Form.Item>
  );
};

export default FormItemDragger;
